module.exports = __webpack_public_path__ + "img/holiday_1_gold-coast.8b5f8b5d.jpg";